<template>
    <div class="container mt-3">
        <div class="col-12">
  

<!-- Modal -->
<div  class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" >
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
  
 
    <table class="w-100">

      <thead>
        <tr>
          <th>სტუდენტი</th>
          <th>მოსვლა</th>
          <th>წასვლა</th>
        </tr>
      </thead>
      <tbody>
         
        <tr v-for="student in students" :key="student.students.studentID">
        <td>{{ student.students.fname }} {{ student.students.lname }}</td>
        <td><input type="datetime-local" class="form-control" v-model="come[student.registrationID]"/></td>
        <td><input type="datetime-local" class="form-control" v-model="leaved[student.registrationID]"/></td>
      </tr>
      </tbody>
      
    </table>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" @click="saveAbscence()">შენახვა</button>
      </div>
    </div>
  </div>
</div>




<button type="button" class="btn btn-success" id="showAbscencesButton" style="display: none;" data-bs-toggle="modal" data-bs-target="#showAbscences">
 დამატება
</button>

<div class="modal fade" id="showAbscences" tabindex="-1" aria-labelledby="showAbscencesLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body"> 
  
        <div v-for="(abscence,i) in abscences" :key="i">
            <h4 class="text-center">{{ abscence.students.fname }} {{ abscence.students.lname }}</h4>
            <table class="table w-100">
              <thead>
                <tr>
                  <th>მოსვლა</th>
                  <th>წასვლა</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(abscenceDate,j) in abscence.abscences" :key="j">
                  <td>{{ abscenceDate.come }}</td>
                  <td>{{ abscenceDate.leaved }}</td>
                </tr>
              </tbody>
            </table>
        </div>


      </div>
      
    </div>
  </div>
</div>






          <table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">მოდული</th>
       <th scope="col">ლექტორი</th>
       <th scope="col">დღე</th>
       <th scope="col">ლექციის დაწყება</th>
       <th scope="col">ლექციის დასრულება</th>
       <th scope="col">მოდულის დაწყება</th>
       <th scope="col">მოდულის დასრულება</th>
     
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="group in groups" :key="group.groupID" >
       <th @dblclick="showStudentsAbscences(group.groupN)" scope="row">{{ group.groupN }}</th>
       <td>{{ group.module_name.module_name }}</td>
       <td>{{ group.person.fname }} {{ group.person.lname }}</td>
       <td>{{ group.day.day }}</td>
       <td>{{ group.lecture_start }}</td>
       <td>{{ group.lecture_end}}</td>
       <td>{{ group.start_date}}</td>
       <td>{{ group.finish_date}}</td>
       <td><button type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="getStudentsInGroup(group.groupN)" class="btn btn-outline-success"><i class='bx bxs-user-account'></i></button> </td>
       
     </tr>
    
   
   
 
   </tbody>
 </table>

      

        </div>

    </div>
</template>
<script>
 import HttpRequests from '../httpRequests/httpRequests';
 const httpRequests= new HttpRequests()
 export default{

  data(){
    return{
      groups:[],
      students:[],
      come:{},
      leaved:{},
      abscences:[]
    }
  },
  mounted(){
    httpRequests.getLecturerGroups().then(response=>{
      this.groups=response.data
    })
  },
  methods:{
    getStudentsInGroup(groupN){

 
  httpRequests.getStudentsInGroup(groupN).then(response=>{
    
    this.students=response.data
   
  })

},
saveAbscence(){
  httpRequests.saveAbscence(this.come,this.leaved).then(()=>{
    location.reload()
  })
},
showStudentsAbscences(groupN){

  document.getElementById('showAbscencesButton').click()
  

  httpRequests.showStudentsAbscences(groupN).then(response=>{
   this.abscences=response.data
    
  })

}
  }


 }

</script>





